import { useRouter } from 'next/router'
import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'

interface IState {
  videoPlaying: boolean
  setVideoPlaying: Dispatch<SetStateAction<boolean>>
}

const defaultState: IState = {
  videoPlaying: false,
  setVideoPlaying: function (value: React.SetStateAction<boolean>): void {
    throw new Error('Function not implemented.' + value)
  },
}
export const OttPlayerContext = createContext(defaultState)
type Props = {
  children: React.ReactNode
}
export const OttPlayerProvider = ({ children }: Props) => {
  const [videoPlaying, setVideoPlaying] = useState(false)
  const router = useRouter()

  useEffect(() => {
    const onRouteChangeStart = () => {
      setVideoPlaying(false)
    }

    router.events.on('routeChangeStart', onRouteChangeStart)
    return () => {
      router.events.off('routeChangeStart', onRouteChangeStart)
    }
  }, [router.events])

  return (
    <OttPlayerContext.Provider value={{ videoPlaying, setVideoPlaying }}>
      {children}
    </OttPlayerContext.Provider>
  )
}
export const useOttPlayer = () => {
  return useContext(OttPlayerContext)
}
